import type { Documento, OrigenArchivo, PaginaDocumento } from '../types'
import { fechaRel } from '../utils/fechas'

function paginas(
  base: string,
  cantidad: number,
  origen: OrigenArchivo,
  rotaciones: number[] = [],
): PaginaDocumento[] {
  return Array.from({ length: cantidad }).map((_, i) => ({
    id: `${base}-p${i + 1}`,
    nombre: `${base}_p${String(i + 1).padStart(2, '0')}.${origen === 'Cámara' ? 'jpg' : 'pdf'}`,
    rotacion: rotaciones[i] ?? 0,
    origen,
  }))
}

/** Evidencias ya digitalizadas en el expediente VER-PEN-2026-0042 (ex-01). */
export const EVIDENCIAS_INICIALES: Documento[] = [
  {
    id: 'ev-001',
    expedienteId: 'ex-01',
    tipoId: 'td-06',
    tipo: 'Denuncia',
    descripcion: 'Denuncia por fraude genérico con anexos contables, sellada por la Fiscalía.',
    fecha: fechaRel(-208),
    fechaAcuse: fechaRel(-207),
    fojas: 34,
    clasificacion: 'Copia certificada',
    archivo: 'VER-PEN-2026-0042-EV001.pdf',
    ubicacion: 'Caja 04 · Legajo 1',
    autoridadEmisora: 'Fiscalía Regional Zona Centro, Veracruz',
    firmaCedula: '8451237',
    fechaVencimiento: fechaRel(-198),
    confidencial: false,
    esEvidencia: true,
    numeroEvidencia: 1,
    etapa: 'Denuncia',
    origen: 'Escáner',
    paginas: paginas('EV001', 4, 'Escáner'),
    subidoPor: 'Lic. Mariana Cervantes Rojo',
    subidoEn: `${fechaRel(-207)} 09:24`,
    versiones: [
      {
        version: 1,
        archivo: 'VER-PEN-2026-0042-EV001.pdf',
        usuario: 'Lic. Mariana Cervantes Rojo',
        fechaHora: `${fechaRel(-207)} 09:24`,
        nota: 'Digitalización inicial desde escáner de recepción.',
      },
    ],
  },
  {
    id: 'ev-002',
    expedienteId: 'ex-01',
    tipoId: 'td-18',
    tipo: 'Prueba pericial',
    descripcion: 'Dictamen pericial contable sobre facturación simulada del ejercicio 2024.',
    fecha: fechaRel(-96),
    fojas: 47,
    clasificacion: 'Privado',
    archivo: 'VER-PEN-2026-0042-EV002-v2.pdf',
    ubicacion: 'Caja 04 · Legajo 2',
    autoridadEmisora: 'Perito contable adscrito, C.P. Enrique Loyo',
    firmaCedula: '7712064',
    cadenaCustodia: 'CC-2026-0114',
    confidencial: false,
    esEvidencia: true,
    numeroEvidencia: 2,
    etapa: 'Carpeta de investigación',
    origen: 'Archivo',
    paginas: paginas('EV002', 6, 'Archivo'),
    subidoPor: 'Lic. Ricardo Menchaca Villalobos',
    subidoEn: `${fechaRel(-88)} 17:05`,
    versiones: [
      {
        version: 1,
        archivo: 'VER-PEN-2026-0042-EV002.pdf',
        usuario: 'Lic. Ricardo Menchaca Villalobos',
        fechaHora: `${fechaRel(-95)} 11:40`,
        nota: 'Primera versión del dictamen, sin anexos numéricos.',
      },
      {
        version: 2,
        archivo: 'VER-PEN-2026-0042-EV002-v2.pdf',
        usuario: 'Lic. Ricardo Menchaca Villalobos',
        fechaHora: `${fechaRel(-88)} 17:05`,
        nota: 'Se reemplaza con la versión firmada e integrada con anexos.',
      },
    ],
  },
  {
    id: 'ev-003',
    expedienteId: 'ex-01',
    tipoId: 'td-24',
    tipo: 'Acuse',
    descripcion: 'Acuse de recibo de la solicitud de copias de la carpeta de investigación.',
    fecha: fechaRel(-40),
    fechaAcuse: fechaRel(-40),
    fojas: 0,
    clasificacion: 'Público',
    archivo: 'VER-PEN-2026-0042-EV003.jpg',
    ubicacion: 'Caja 04 · Legajo 2',
    confidencial: false,
    esEvidencia: true,
    numeroEvidencia: 3,
    etapa: 'Carpeta de investigación',
    origen: 'Cámara',
    paginas: paginas('EV003', 1, 'Cámara', [90]),
    subidoPor: 'Sra. Leticia Ordaz (Archivo VER)',
    subidoEn: `${fechaRel(-40)} 13:12`,
    versiones: [
      {
        version: 1,
        archivo: 'VER-PEN-2026-0042-EV003.jpg',
        usuario: 'Sra. Leticia Ordaz (Archivo VER)',
        fechaHora: `${fechaRel(-40)} 13:12`,
        nota: 'Fotografía tomada con tablet en ventanilla de la Fiscalía.',
      },
    ],
  },
  {
    id: 'ev-004',
    expedienteId: 'ex-01',
    tipoId: 'td-17',
    tipo: 'Prueba documental',
    descripcion:
      'Estados de cuenta bancarios de la empresa correspondientes al periodo investigado.',
    fecha: fechaRel(-22),
    fojas: 62,
    clasificacion: 'Privado',
    archivo: 'VER-PEN-2026-0042-EV004.pdf',
    ubicacion: 'Caja 04 · Legajo 3',
    cadenaCustodia: 'CC-2026-0177',
    confidencial: false,
    esEvidencia: true,
    numeroEvidencia: 4,
    etapa: 'Audiencia inicial',
    origen: 'Escáner',
    paginas: paginas('EV004', 8, 'Escáner'),
    subidoPor: 'Lic. Mariana Cervantes Rojo',
    subidoEn: `${fechaRel(-21)} 08:47`,
    versiones: [
      {
        version: 1,
        archivo: 'VER-PEN-2026-0042-EV004.pdf',
        usuario: 'Lic. Mariana Cervantes Rojo',
        fechaHora: `${fechaRel(-21)} 08:47`,
        nota: 'Digitalización por lotes, 8 páginas agrupadas en un documento.',
      },
    ],
  },
]
